'use client';

// Package Imports
import React from 'react';
import Link from 'next/link';

// Type Imports
import { BreadcrumbProps } from '@/lib/types/breadcrumbs';

import BreadcrumbSchema from '@/lib/schema/breadcrumbSchema';

// Style Imports
import styles from './breadcrumbs.module.scss';

const Breadcrumb = ({ items, variant = 'left' }: BreadcrumbProps) => {
  return (
    <>
      <BreadcrumbSchema items={items!} />
      <nav aria-label='breadcrumb' className={styles[variant]}>
        <ol className={styles.breadcrumbs}>
          <li>
            <Link href='/'>Home</Link>
          </li>
          {items?.map((link, index) => {
            return (
              <li key={index}>
                {index === items.length - 1 ? <span>{link.label}</span> : <Link href={link.href}>{link.label}</Link>}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumb;
